/**
 * Build Info — compile-time metadata injected by Vite / Rolldown `define`.
 *
 * Each app injects `__BUILD_INFO__` via its build config:
 *   define: { __BUILD_INFO__: JSON.stringify({ version, buildTime, app }) }
 *
 * This module provides type-safe access with sensible defaults.
 */

export interface BuildInfo {
    /** App name (e.g. "editor", "web", "play", "cli", "engine") */
    app: string;
    /** Version from package.json */
    version: string;
    /** ISO 8601 build timestamp */
    buildTime: string;
    /** Git commit short hash (optional) */
    gitHash?: string;
}

declare global {
    const __BUILD_INFO__: BuildInfo | undefined;
}

const fallback: BuildInfo = {
    app: "unknown",
    version: "dev",
    buildTime: new Date().toISOString(),
};

/** Get build info injected at compile time. */
export function getBuildInfo(): BuildInfo {
    try {
        if (typeof __BUILD_INFO__ !== "undefined" && __BUILD_INFO__) {
            return __BUILD_INFO__;
        }
    } catch {
        /* not defined */
    }
    return fallback;
}
